import React from 'react'
import classnames from 'classnames'
import { zeroPad } from 'react-countdown'

const countdownRenderer = className => ({ hours, minutes, seconds, completed }) =>
  !completed && (
    <span className={classnames('text-white', className)}>
      {zeroPad(hours)}h : {zeroPad(minutes)}m : {zeroPad(seconds)}s
    </span>
  )

export default countdownRenderer
